import { Doughnut } from 'react-chartjs-2'
import { formatNumber } from '../../utils/string-utils'
import { renderResult } from '../../pages/extension/telesale'
import { colorPalette } from '../../utils/color-utils'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js'

// Register Chart.js components and plugins
ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    Title,
    ChartDataLabels
)

export default function ChartAmountType({ data, title }: any) {
    const types = data?.filter((item: any) => item.sum > 0).map((item: any) => {
        const percent = item.sum / data.total * 100
        return {
            type: item.type,
            sum: item.sum,
            hidden: percent < 5,
        }
    }).sort((a: any, b: any) => a.sum - b.sum)

    const labels = types?.map((item: any) => renderResult(item.type))

    const datasets = [
        {
            data: types?.map((item: any) => item.sum),
            backgroundColor: types?.map((_: any, index: number) => colorPalette[index % colorPalette.length]),
            borderColor: 'white',
            borderWidth: 2,
            hoverOffset: 10,
        },
    ] as any

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            tooltip: {
                callbacks: {
                    label: (context: any) => formatNumber(context.raw),
                },
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 16,
                },
                padding: {
                    bottom: 24,
                },
            },
            datalabels: {
                formatter: (_: any, value: any) => {
                    const sum = types[value.dataIndex].sum
                    const hidden = types[value.dataIndex].hidden
                    return hidden ? '' : formatNumber(sum)
                },
                color: 'white',
                textShadow: '0px 0px 2px rgba(0, 0, 0, 0.5)',
                font: {
                    weight: 'bold',
                    size: 14,
                },
                backgroundColor: (context: any) => {
                    // Get a slightly darker version of the segment color for better contrast
                    return context.dataset.backgroundColor[context.dataIndex];
                },
                borderRadius: 4,
                padding: {
                    top: 4,
                    bottom: 4,
                    left: 6,
                    right: 6
                },
                display: (context: any) => {
                    // Only show labels for segments with enough space
                    return context.dataset.data[context.dataIndex] / context.dataset.data.reduce((a: number, b: number) => a + b, 0) > 0.05;
                },
            },
        },
    } as any

    return (
        <Doughnut data={{ labels, datasets }} options={options} />
    )
}
